const actions = {
  setType: 'SET::DEVICE_TYPE'
}

export const setDeviceType = type => ({ type: actions.setType, deviceType: type })

export default actions
